/**
 * Phase F.6 Batch D — Clickable info bubble (replaces the read-only "?" icons across the app).
 * Usage: <InfoBubble title="What this does" body="Long-form explanation…" />
 * Optionally pass `link` for a "Learn more" link.
 */
import React, { useState } from "react";
import { HelpCircle, Info } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "./ui/popover";

export function InfoBubble({ title, body, link, icon: Icon = HelpCircle, size = "sm", className = "", testid }) {
  const [open, setOpen] = useState(false);
  const sizeClass = size === "xs" ? "h-3 w-3" : size === "lg" ? "h-5 w-5" : "h-3.5 w-3.5";
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={title || "More info"}
          className={`inline-flex items-center justify-center text-muted-foreground hover:text-foreground transition-colors ${className}`}
          data-testid={testid || "info-bubble"}
        >
          <Icon className={sizeClass} />
        </button>
      </PopoverTrigger>
      <PopoverContent className="max-w-xs text-sm space-y-2" align="start">
        {title && <p className="font-semibold flex items-center gap-1.5"><Info className="h-3.5 w-3.5" />{title}</p>}
        {body && <p className="text-xs text-muted-foreground leading-relaxed">{body}</p>}
        {link && (
          <a href={link} target="_blank" rel="noreferrer" className="text-xs text-cyan-600 hover:underline">
            Learn more →
          </a>
        )}
      </PopoverContent>
    </Popover>
  );
}

export default InfoBubble;
